import React, { useState, useImperativeHandle, forwardRef } from 'react';

import ReactTable from 'components/ReactTable/ReactTable';
import { DateFilteredTableProps } from '../types';
import DateFilteredComponent from '../dateFiltered/dateFilteredComponent/dateFilteredComponent';

export interface ExamPaymentsDateFilteredTableRef {
  getTableData: () => any[];
}

const ExamPaymentsDateFilteredTable = forwardRef<ExamPaymentsDateFilteredTableRef, DateFilteredTableProps>(({
  fetchMethod,
  columns,
}, ref) => {
  const [tableData, setTableData] = useState<any>([]);

  useImperativeHandle(ref, () => ({
    getTableData: () => tableData,
  }));

  return (
    <>
      <div className="filtered-table__container">
        <DateFilteredComponent
          component={[
            <ReactTable
              data={tableData}
              columns={columns}
              topPaginationClassName="table-pagination_top"
              isLastColumnSortable={true}
            />]
          }
          fetchMethod={fetchMethod}
          updateDataMethod={setTableData}
          componentName="table"
        />
      </div>
    </>
  );
});

ExamPaymentsDateFilteredTable.displayName = 'ExamPaymentsDateFilteredTable';

export default ExamPaymentsDateFilteredTable;
